




import app from "@/app";
import { SXCompany, SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WSurveyAdd extends BaseComponent {
	@Prop({ type: SXCompany, required: true })
	company!: SXCompany;

	title = "SX_LANG_SURVEY_ADD";

	get form() {
		return getForm();
	}

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			required = [SXSurvey.COL_NAME, SXSurvey.COL_DESCRIPTION],
			fv = app.getFormValidator(form, required);

		if (fv.validate()) {
			let formData = fv.getFormData();

			if (!fv.getField(SXSurvey.COL_VISIBILITY)) {
				formData.append(SXSurvey.COL_VISIBILITY, "0");
			}
			if (!fv.getField(SXSurvey.COL_REQUIRE_USER)) {
				formData.append(SXSurvey.COL_REQUIRE_USER, "0");
			}

			formData.append(SXSurvey.COL_COMPANY_ID, this.company.id);

			app.services.surveys.add(formData, function() {
				app.router.goBack();
			});
		}
	}
}

const getForm = function() {
	return {
		fields: {
			name: {
				field: "input",
				label: { i18n: "SX_LANG_NAME" },
				attrs: {
					name: SXSurvey.COL_NAME,
					minlength: 3,
					maxlength: 200,
					autocomplete: "off"
				}
			},
			description: {
				field: "textarea",
				label: { i18n: "SX_LANG_DESCRIPTION" },
				attrs: {
					name: SXSurvey.COL_DESCRIPTION,
					minlength: 3
				}
			},
			require_user: {
				field: "checkbox",
				label: { i18n: "SX_LANG_REQUIRE_USER" },
				attrs: {
					name: SXSurvey.COL_REQUIRE_USER
				}
			},
			visibility: {
				field: "checkbox",
				label: { i18n: "SX_LANG_VISIBILITY" },
				attrs: {
					name: SXSurvey.COL_VISIBILITY
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
